
export function isArrayContain (arr, key, val) {


    const temparray = [] as any[];

    for (const item of arr) {
        temparray.push(item[key])
        // if (item[key] === val) {
            // isContain = true;
            // break;
        // }
    }
    console.log('finding...' + val + ' in: ' + temparray)

    return temparray.includes(val)
}

export function getKeyVal (key) {
    return sessionStorage.getItem(key + '') || false
}

export function saveKeyVal (key, val) {
    sessionStorage.setItem(key + '', val + '')
}

export function dateToString(dateitem) {
    const utcTime = new Date(dateitem)
    let dd = utcTime.getDate() as any; 
    let mm = utcTime.getMonth()+1 as any;
    const yyyy = utcTime.getFullYear(); 
    let hh = utcTime.getHours() as any; 
    let min = utcTime.getMinutes() as any; 
    let ss = utcTime.getSeconds() as any; 
    if(dd<10){dd='0'+dd} 
    if(hh<10){hh='0'+hh};
    if(ss<10){ss='0'+ss};
    if(min<10){min='0'+min};
    if(mm<10){mm='0'+mm};
    return yyyy + "-" + mm + "-" + dd + " " + hh + ":" + min + ":" + ss;
    // return utcTime.toJSON().slice(0, 10)
  }

export function processDrag(items) {
    const choices = [] as any [];

    for (const row of items) {
        choices.push({
            drag: row.question,
            drop: row.answer,
            completion: row.completion_text,
            id: row.id
        });
    }
    return choices;
}

export function processRedWords (items) {
    let redwords = '';

    for (const row of items) {
        redwords = redwords + row.word + ','
    }

    return redwords.substring(0, (redwords.length -1));
}

export function decodeSocketMessage(data) {
    const decodedData = new TextDecoder().decode(data);
    return JSON.parse(decodedData);
}


// WEBPACK FOOTER //
// ./src/common/utils.ts